import { useEffect } from "react";
import { useMap } from "react-leaflet";
import type { MapLocation } from "../../utils/types";

export type MapCenterHandlerProps = {
  locations: MapLocation[];
  foundLocation?: MapLocation | null;
  /** When false, do not recenter to foundLocation (e.g. when marker was placed by map click). */
  recenterToFoundLocation?: boolean;
};

export const MapCenterHandler = ({
  locations,
  foundLocation,
  recenterToFoundLocation = true,
}: MapCenterHandlerProps) => {
  const map = useMap();
  useEffect(() => {
    if (foundLocation && !recenterToFoundLocation) return; // placed by click, don't recenter
    if (foundLocation && recenterToFoundLocation) {
      map.flyTo([foundLocation.latitude, foundLocation.longitude], 14, { animate: true });
      return;
    }
    if (locations && locations.length > 0) {
      map.flyTo([locations[0].latitude, locations[0].longitude], map.getZoom());
    }
  }, [foundLocation, locations, map, recenterToFoundLocation]);

  return null;
};
